<template>
    <header v-if="!isLoggedOutRoute" ref="headerRef" :class="[
        'flex items-center gap-0 sm:gap-2 header-root border-b !border-muted/10 !bg-transparent w-[calc(100vw)]  sm:w-full min-h-[64px] ',
        {
          'pt-1 !h-14': isTeamRoute,
        }
    ]"
    :style="headerStyle">
        <slot name="menu" />
        
        <div class="flex-1" />
        
        <!-- <Button variant="ghost" size="icon" @click="colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'" class="hidden md:block">
            <Icon v-if="colorMode.value === 'dark'" name="material-symbols:light-mode" size="24"/>
            <Icon v-if="colorMode.value === 'light'" name="ph:moon" size="20"/>
        </Button> -->
        <div class="flex items-center gap-1">
        </div>
        <slot name="dropdownmenu" />
    </header>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { useUiStore } from '@/stores/uiStore'

const route = useRoute()
const { toggleBottomSheet } = useUiStore()
const user = useSupabaseUser()

const props = defineProps<{
  scrollY: number
}>()

// Add computed property to check if we're on a team route
const isTeamRoute = computed(() => {
  return route.params.team || route.path.includes('/team/')
})

const isLoggedOutRoute = computed(() => {
  const disallowed = ['login', 'register', 'confirm', 'reset-password', 'maintenance']
  const currentPath = route.path || ''
  return disallowed.some(path => currentPath.includes(path))
})



// Compute header styles based on scroll position
const headerStyle = computed(() => {
  // Team route has fixed height
  if (isTeamRoute.value) {
    return {
      height: '64px',
      padding: '0 1rem'
    }
  }

  // Non-home routes have fixed height
  if (route.path !== '/') {
    return {
      height: '64px',
      padding: '0 1rem',
      backdropFilter: 'blur(24px)'
    }
  }

  // Home route - smooth transition based on scroll
  const maxScroll = 100
  const progress = Math.min(1, props.scrollY / maxScroll)
  
  const height = 180 - (116 * progress) // 180px to 64px
  const horizontalPadding = progress < 0.1 ? '4vw' : '1rem'
  const verticalPadding = progress < 0.1 ? '4vw' : '0'
  
  return {
    height: `${height}px`,
    padding: `${verticalPadding} ${horizontalPadding}`,
    backdropFilter: progress > 0.1 ? 'blur(24px)' : 'none',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
  }
})

</script>

<style scoped>
.header-root {
  will-change: height, padding, backdrop-filter;
}

@media (max-width: 767px) {
  .header-root {
    height: 64px !important;
    padding: 0 1rem !important;
  }
}
</style>


